import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

import merchants from "@/api/merchants";

import MerchantsTable from "../Components/MerchantsTable";
import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import UpdateMerchantModal from "../MerchantDetails/UpdateMerchantModal";

const AllType = {
  id: -1,
  name: "All",
};

class Merchants extends Component {
  table = React.createRef();

  state = {
    selectedType: "All",
    types: [],
    isUpdateMerchantModalOpen: false,
  };

  componentDidMount() {
    merchants.getMerchantTypes().then(({ data }) => {
      this.setState({
        types: data,
      });
    });
  }

  loadPagination = async (page = 0, size = 10, search, sort) => {
    const type =
      this.state.selectedType === "All" ? undefined : this.state.selectedType;
    let result = await merchants.getMerchants(page, size, search, sort, type);
    return result;
  };

  handleTypeChange = event => {
    this.setState(
      {
        selectedType: event.target.value,
      },
      () => {
        this.table.loadAndStoreData();
      },
    );
  };

  onToggleUpdateMerchantModal = () => {
    this.setState(({ isUpdateMerchantModalOpen }) => {
      if (isUpdateMerchantModalOpen) {
        this.table.loadAndStoreData();
      }
      return {
        isUpdateMerchantModalOpen: !isUpdateMerchantModalOpen,
      };
    });
  };

  render() {
    const typesWithAll = [AllType, ...this.state.types];

    return (
      <>
        <div className="animated fadeIn">
          <Row>
            <Col>
              <Card>
                <CardHeader>Merchants</CardHeader>
                <CardBody>
                  <Form
                    inline
                    style={{
                      marginBottom: ".5rem",
                      justifyContent: "flex-end",
                    }}>
                    <FormGroup
                      className="mb-2 mr-sm-2 mb-sm-0"
                      style={{ paddingRight: "2rem", alignItems: "baseline" }}>
                      <Label htmlFor="type" style={{ marginRight: "1rem" }}>
                        <h6>Type:</h6>
                      </Label>
                      <Input
                        type="select"
                        name="category"
                        id="type"
                        value={this.state.selectedType}
                        style={{
                          maxWidth: "300px",
                        }}
                        onChange={this.handleTypeChange}>
                        {typesWithAll.map(type => {
                          return (
                            <option value={type.name} key={type.id}>
                              {type.name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Button
                        color="success"
                        type="button"
                        onClick={this.onToggleUpdateMerchantModal}>
                        Add merchant
                      </Button>
                    </FormGroup>
                  </Form>
                  <TableContainerWithLocation
                    loadData={this.loadPagination}
                    wrappedComponentRef={innerComponent => {
                      if (innerComponent) {
                        this.table = innerComponent;
                      }
                    }}>
                    <MerchantsTable />
                  </TableContainerWithLocation>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>

        <UpdateMerchantModal
          isOpen={this.state.isUpdateMerchantModalOpen}
          onModalClose={this.onToggleUpdateMerchantModal}
          addNew
          types={this.state.types.filter(type => type.status === "ACTIVE")}
        />
      </>
    );
  }
}

export default Merchants;
